/**
 * GitHub Pages serves unknown paths as `404.html`, which redirects to
 * `/?/real/path&rest…`. React Router must see `/real/path?rest…` before it
 * mounts. This also handles `?%2F…` when the leading slash is percent-encoded.
 *
 * Kept as a side-effect import at the top of `index.js` so it runs before
 * `BrowserRouter` reads `window.location`.
 */
(function normalizeGithubPagesSpaUrl() {
  if (typeof window === 'undefined') return;
  const l = window.location;
  let search = l.search;
  if (
    search.length >= 4 &&
    search.substring(0, 4).toLowerCase() === '?%2f'
  ) {
    try {
      search = decodeURIComponent(search);
    } catch {
      /* ignore malformed percent-escapes */
    }
  }
  if (search.length > 1 && search[1] === '/') {
    const decoded = search
      .slice(1)
      .split('&')
      .map((s) => s.replace(/~and~/g, '&'))
      .join('?');
    const nextUrl = `${l.pathname.slice(0, -1)}${decoded}${l.hash}`;
    window.history.replaceState(null, '', nextUrl);
  }
})();
